import React, { Component } from 'react';
import { ICourseList } from '../../models/pages/coursePage';
import { Common } from '../../core/common';
import { SecureImage } from '../../components/core/secureImage';
import ProgressCircle from '../../components/progress-circle/progress-circle';
import { Log } from 'ng2-logger';
import Translator from '../../core/i18n';
import ClassList from './classList';
import * as ActionsCoursePage from '../../store/actions/coursePage';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { IAction, IAppState } from '../../models/action/core';
import { UserType } from '../../models/pages/login.d';
import moment from 'moment';
import Loading from '../../components/loading/loading';
import * as Actions from '../../store/actions/userHome';
import ReactGA from 'react-ga4';
import Tooltip from '../../components/tooltip/main';

let _common: Common;

const _logger = Log.create('courseList');

const T = Translator.create();

export class CCourseList extends Component<ICourseList, any> {

    constructor(props: any) {
        super(props);
        _common = new Common();

        this.state = {
            isTeacher: this.props.userType && (this.props.userType === UserType.Teacher || this.props.userType === UserType.ProgramAdmin),
            today: moment().format('yyyy-MM-DDTHH:mm:ss'),
            filters: {
                termId: 0,
                programId: 0,
                status: -1,
                sourceCourseId: '',
                courseId: ''
            },
            classesFilters: {
                take: 3,
                page: 1,
                total: 0
            },
            count: 0,
            isOpen: false,
            prevCourseId: '',
            activeCourses: this.props.userHomeMyCourses && this.props.userHomeMyCourses.length > 0 ? this.findActiveCourses() : [],
            showMoreStates: {}
        }
        this.afterCourseStar = this.afterCourseStar.bind(this);

    }

    componentDidUpdate(prevProps: any) {
        if (prevProps.userHomeMyCourses &&
            this.props.userHomeMyCourses &&
            prevProps.userHomeMyCourses !== this.props.userHomeMyCourses) {
            this.setState({
                activeCourses: this.props.userHomeMyCourses && this.props.userHomeMyCourses.length > 0 ? this.findActiveCourses() : []
            }
            );
        }
    }

    public navigateUrl(classId?: string | null, activityId?: string | null) {
        ReactGA.event({
            category: window.location.host,
            action: 'G_LESSON_ID_' + activityId + '_MYLESSONS',
            label: 'G_LESSON_ID_' + activityId + '_MYLESSONS',
            nonInteraction: true,
        });
        const url = 'course?classId=' + classId + '&activityId=' + activityId + '&type=1';
        this.props.history.push(url);
    }

    public getTeachersClasses = async (courseId: string) => {
        if (this.state.prevCourseId === '') {
            this.props.dispatch(ActionsCoursePage.getCourseClassesData(courseId, this.state.classesFilters, 'getCourseClassesData', 'get'));

            setTimeout(() => {
                $('#myClassesList' + courseId).slideDown();
            }, 300)
            this.setState({ prevCourseId: courseId });
        }
        else {
            if (this.state.prevCourseId === courseId) {

                setTimeout(() => {
                    $('#myClassesList' + this.state.prevCourseId).slideUp();
                }, 300)
                this.setState({ prevCourseId: '' });
            } else {
                $('#myClassesList' + this.state.prevCourseId).slideUp();
                this.props.dispatch(ActionsCoursePage.getCourseClassesData(courseId, this.state.classesFilters, 'getCourseClassesData', 'get'));

                setTimeout(() => {
                    $('#myClassesList' + courseId).slideDown();
                }, 300)
                this.setState({ prevCourseId: courseId });
            }
        }
    }

    dateCondition(endDate: any, startDate: any, termId: any) {
        const nowDate = moment().format('yyyy-MM-DDTHH:mm:ss');
        const firstDate = moment.utc("0001-01-01");
        return termId !== null && endDate && startDate && (moment.utc(startDate).isAfter(firstDate)) && (moment.utc(endDate).isAfter(firstDate)) ? (endDate.toString() >= nowDate) : true
    }

    findActiveCourses() {
        const isTeacher = this.props.userType && (this.props.userType === UserType.Teacher || this.props.userType === UserType.ProgramAdmin)
        if (this.props.userHomeMyCourses && this.props.userHomeMyCourses.length > 0) {
            const activeCourses = this.props.userHomeMyCourses.filter(item => item.activeStatus !== -1 && item.classId !== null &&
                (isTeacher ? (this.dateCondition(item.endDate, item.startDate, item.termId)) : (this.dateCondition(item.courseEndDate, item.courseStartDate, item.termId))))
            return activeCourses.sort((a, b) => b.activeStatus! - a.activeStatus!);
        }
    }

    courseStar(courseId: any) {
        this.props.dispatch(ActionsCoursePage.setTriggerCourseStar(courseId, 'setTriggerCourseStar', 'set', this.afterCourseStar));
    }

    afterCourseStar() {
        this.props.dispatch(Actions.getUserHomeMyCourses(this.state.isTeacher, 'getUserHomeMyCourses', 'get', '', this.props.searchfilters ? this.props.searchfilters : this.state.filters));
    }

    renderShowMoreButtons(item: string, isShow: boolean, itemId: string, limit: number) {
        return (
            <>
                {isShow ? item : `${item.substring(0, limit)}...`}
                <button
                    onClick={() => {
                        this.setState((prevState: any) => {
                            const newState = !prevState.showMoreStates[itemId]?.isShow || false; // Durumu tersine çevir
                            return { showMoreStates: { ...prevState.showMoreStates, [itemId]: { isShow: newState } } }; // Durumu güncelle
                        });
                    }}
                    className={isShow ? 'float-right ml-3' : 'float-right show_more_text'}
                    style={{
                        fontSize: '12px',
                        margin: '0px 0px 0px 10px',
                        color: isShow ? '#ff0000' : '#39B27B',
                        border: 'none',
                        background: 'none'
                    }}
                >
                    {T.t(isShow ? 'r_gen_show_less' : 'r_gen_show_more')}
                </button>
            </>

        )
    }

    renderCourseOptions(item: any) {
        return (
            <div className="col-md-4 course_options">
                {this.state.isTeacher &&
                    <div className='d-flex flex-column justify-content-center align-items-center'>
                        <span style={{ color: 'orange',marginBottom:-5 }} className="badge badge-pill badge-light">
                            {item.classCount}
                        </span>
                        <div className="list-icons">
                            <a className=" " data-toggle="collapse" href={"#myClassesList".concat(item.courseId)}
                                role="button" onClick={this.getTeachersClasses.bind(this, item.courseId)}>
                                <i className="material-icons" style={{ fontSize: " xx-large" }}>
                                  {this.state.prevCourseId == item.courseId ? 'expand_less': 'expand_more'}
                                </i>
                            </a>
                        </div>
                    </div>
                }
                <div className="list-icons ml">
                    <a className=" " style={{ cursor: 'pointer' }} onClick={this.courseStar.bind(this, item.courseId)}>
                        {item.starred ?
                           <img  src={_common.GetDefaultIcons('star_full_icon')}
                           alt="courseStar" />
                            :
                            <img  src={_common.GetDefaultIcons('star_icon')}
                            alt="courseStar" />
                        }
                    </a>
                </div>
                <div className="list-icons " >
                <Tooltip data= {item.newActivityCount && item.newActivityCount > 0 ?
                                (<span className="text-white">{T.t('r_gen_student_newActivity_info').replace('{0}', item.newActivityCount!)} </span>)
                                : <span className="text-white">{T.t('r_gen_student_no_newActivity_info')}</span>} position='top'>
                    <a className={(item.newActivityCount && item.newActivityCount > 0) ? 'notify-dot' : 'opacity-3'} onClick={this.navigateUrl.bind(this, item.classId, item.courseId)} style={{ cursor: 'pointer' }}>

                        {/* <i className={(item.newActivityCount && item.newActivityCount > 0) ? 'notify-dot' : 'opacity-3'}>
                            <img
                                src={_common.GetDefaultIcons('new')}
                                alt="newActivityCount" />
                        </i> */}
                        <img  src={_common.GetDefaultIcons('warning_icon')}
                           alt="warning_icon_icon" />

                    </a>
                    </Tooltip>
                </div>
                <div className="list-icons " >
                <Tooltip data={item.upcomingActivity && item.upcomingActivity > 0 ?
                            T.t('r_activity_deadline_criteria_warning').replace('{0}', item.upcomingActivity!):
                           T.t('r_no_activity_deadline_criteria_warning')} position='top'>
                    <a className={(item.upcomingActivity && item.upcomingActivity > 0) ? 'notify-dot' : 'opacity-3'} onClick={this.navigateUrl.bind(this, item.classId, item.courseId)} style={{ cursor: 'pointer' }}>
                    <img  src={_common.GetDefaultIcons('clock_icon')}
                           alt="clock_icon" /></a>
                    </Tooltip>
                </div>
                <div className="list-icons ">
                <Tooltip data={T.t('r_gen_student_newAnnouncement_count').replace('{0}', item.isNotifications!)} position='top'>
                    <a className={(item.isNotifications && item.isNotifications > 0) ? 'notify-dot' : 'opacity-3'} onClick={this.navigateUrl.bind(this, item.classId, item.courseId)}>
                        {/* <i className={(item.isNotifications && item.isNotifications > 0) ? 'material-icons notify-dot' : 'material-icons'} style={(item.isNotifications && item.isNotifications > 0) ? { color: '#000000' } : { color: '#c9c8c5' }}>
                            forum
                        </i> */}
                        <img  src={_common.GetDefaultIcons('forum_icon')}
                           alt="forum_icon" />
                    </a>
                    </Tooltip>
                </div>
                <div className="list-icons">
                        <ProgressCircle percent={item.progress} />
                </div>
            </div>
        )
    }

    renderCourseInfo(item: any) {
        const teacherKey = `teacher_${item.courseId}`;
        const programKey = `program_${item.courseId}`;
        return (
            <div className="d-flex flex-column my_courses_name" style={{ marginTop: -3.5, width: '85%' }}>
                <div className="alms-h6 d-flex course_term_flex" style={{ whiteSpace: 'pre-line' }}>
                    <div>
                        {
                            <div className="mobile-mt1">
                                <div>
                                    <span className='mt-1'>
                                        {item.programName && item.programName.length > 59 ?
                                            this.renderShowMoreButtons(item.programName,this.state.showMoreStates[programKey]?.isShow || false,programKey, 59)
                                            : item.programName}
                                    </span>
                                </div>
                            </div>
                        }
                    </div>
                    {item.activeStatus === 0 &&
                        <div>
                            {item.activeStatus === 0 ? <span className="archived_tag">{T.t('r_menu_course_archived2')}</span> : ''}
                        </div>
                    }
                    <div className="mobile-activity-edit" style={{paddingInlineStart: "5px"}}>
                        {item.termName ? <span className="term_tag">{item.termName}</span> : <span className="term_tag">{T.t('r_gen_non_term_courses')}</span>}

                    </div>
                </div>
                <button className="mt-0 hiddenText courseName" onClick={this.navigateUrl.bind(this, item.classId, item.courseId)} style={{ cursor: 'pointer', marginBottom: 8 }}>
                    <h6 className={"mt-0 text-truncate" + (!_common.isArabic((item.name) ? item.name : '', document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')}>{(item.name) ? item.name : ''}</h6></button>
                <span className={"course-teacher" + (!_common.isArabic(item.teachers, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')}>
                    {item.teachers && item.teachers.length > 100 ?
                        this.renderShowMoreButtons(item.teachers, this.state.showMoreStates[teacherKey]?.isShow || false, teacherKey, 100)
                        : item.teachers}
                </span>
            </div>
        )
    }


    public render() {
        const maxCourseToShow = this.state.activeCourses.length;
        return (
            <><Loading spinnerId={'getUserHomeMyCourses'} />
                <div id="getUserHomeMyCourses_Content">{this.state.activeCourses && this.state.activeCourses.length > 0 ?
                    this.state.activeCourses.slice(0, maxCourseToShow).map((item: any, index: any) =>
                        <li id="getUserHomeMyCourses_Content" className={item.activeStatus === 0 ? "active_course_list_item archived_lesson" : "active_course_list_item"} /*onClick={this.navigateUrl.bind(this, item.classId, item.courseId)}*/ key={item.courseId}>
                            <div className="row">
                                <div className="col-md-8 course_info">
                                    <SecureImage imageUrl={item.logoUrl!} style={null} class={'course-icon'} imgType={'smallCourse'} />
                                    {this.renderCourseInfo(item)}
                                </div>
                                {this.renderCourseOptions(item)}
                            </div>
                            <div className="collapse mt-3" id={"myClassesList".concat(item.courseId)}>
                                <ClassList {...this.props} />
                            </div>
                        </li>

                    )
                    : ''}
                </div></>);
    }
}

const mapStateToProps = (state: IAppState, ownProps: ICourseList): ICourseList => {
    if (!state) {
        return ownProps;
    }
    const newProps: ICourseList = Object.assign({}, ownProps, {
        userHomeMyCourses: state.userHomePage.userHomeMyCourses,
        useHomeMyCoursesIsLoading: state.userHomePage.useHomeMyCoursesIsLoading,
        userType: state.login.identitiy.userType,
        userMyClasses: state.coursePage.userMyClasses,
        searchfilters: state.userHomePage.searchfilters
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        // next.userHomePage.useHomeMyCoursesIsLoading === prev.userHomePage.useHomeMyCoursesIsLoading
        next.userHomePage.userHomeMyCourses === prev.userHomePage.userHomeMyCourses &&
        next.coursePage.userMyClasses === prev.coursePage.userMyClasses &&
        next.userHomePage.searchfilters === prev.userHomePage.searchfilters
    );
    return ret;
};
const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return ({
        dispatch
    });
};


const CourseList = connect(
    mapStateToProps,
    dispatchProps,
    null, {
    areStatesEqual
}
)(CCourseList);

export default CourseList;
